import { cartOperations } from '../../state/cart';

/**
 * Hook that returns the hostControlsV1 contract for UX Mods.
 */
export const useHostControlsV1Library = dispatch => {
  const refreshHost = () => {
    dispatch(cartOperations.cartChangedExternally());
  };

  return { refreshHost };
};
